var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandArcStyleBlack = function SvgBrandArcStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m4.036 15.434-1.073 2.257c-.547 1.147-.136 2.56.989 3.158a2.36 2.36 0 0 0 3.236-1.067l.98-2.059a12.25 12.25 0 0 1-4.132-2.289M20.995 5.865a2.356 2.356 0 0 0-2.774 1.85c-.226 1.131-.756 2.185-1.487 3.08l2.143 4.513c1.979-1.716 3.44-4.054 3.964-6.669a2.354 2.354 0 0 0-1.846-2.774"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.738 13.359a6 6 0 0 1-1.396.168c-.365 0-.744-.042-1.122-.123-1.568-.333-3.145-1.303-4.038-2.483a4 4 0 0 1-.53-.914 2.36 2.36 0 0 0-3.068-1.303 2.36 2.36 0 0 0-1.302 3.067c.552 1.371 1.529 2.629 2.754 3.663a12.2 12.2 0 0 0 4.128 2.289c1.038.333 2.114.517 3.175.517 1.176 0 2.337-.203 3.442-.575z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m20.009 17.68-3.275-6.888-.003.003q0-.001.003-.003l-3.116-6.556a2.357 2.357 0 0 0-4.255 0l-3.177 6.685c.892 1.18 2.47 2.15 4.037 2.483l1.028-2.16a.269.269 0 0 1 .485 0l1.006 2.115 3.051 6.42a2.35 2.35 0 0 0 2.758 1.258c1.419-.392 2.091-2.024 1.458-3.356"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandArcStyleBlack);
export { ForwardRef as ReactComponent };